import { axiosInterceptorInstance, axiosAuthInstance } from 'api'

export const authApi = {
  login: (values) => axiosAuthInstance('/login', values),

  profile: () => axiosInterceptorInstance.get(`/auth/user/details`),

  logout: () => axiosInterceptorInstance.get('/auth/logout'),

  loginAsUser: (id) =>
    axiosInterceptorInstance.get(`/auth/login-as-user/${id}`),
}
